
export default {
  path:'/invest',
  redirect: {name:'invest'},
  component:() => import('@/pages/s'),
  children:[
    // 投资列表
    {
      path:'list',
      name:'invest',
      component:() => import('@/pages/invest/list')
    },
    // 投资详情
    {
      path:'details/:id',
      name:'borrowDetails',
      component:() => import('@/pages/invest/details')
    },
  ]
}